import { BaseService } from './../base'
export class CivilStatusService extends BaseService {
    static get entity () {
        return 'civil_status'
    }
    static get name () {
        return 'civil_status'
    }
}